import { concat, get } from 'lodash';
import React, { FC } from 'react';
import CreateTable from 'src/components/ui-component/form-component/create-form/CreateTable';
import { useApplication } from 'src/context/ApplicationContext';
import { KATEGORIE_EBENE_DER_BERECHNUNNG, KOSTEN_POSITION, PLATZHALTER_TEXT, UEBERARBEITUNGS_HINWEIS_TITLE } from 'src/lib/constants/constant';
import Schema from 'src/lib/paths/antrag_FULL_Paths.json';
import KostenSchema from 'src/lib/paths/kostenposition_FULL_Paths.json';
import { FormStrucItem } from 'src/lib/types/types';
import { ForceTrue, GetTextboxValidation, NonRequired } from 'src/lib/validation/ValidationTypes';
import {
	checkIfAnyPositionNachPositionArtHasComment,
	checkIfSpecificKostenPositionHasComment,
} from 'src/pages/private/online-antrag/application-helper-function/PruefAssistenzHelperFunktion';
import { DisplayEuro } from 'src/utils/formats';
import { checkReadOnlyInUeberarbeitung } from 'src/utils/helper';
import ApplicationHeading from '../../../../application-heading/ApplicationHeading';

// import Schemas
const P = Schema.attributes;
const KP_P = KostenSchema.attributes;

const AusgabeplanMessefoerderung: FC<{ isKostenEditable: boolean }> = ({ isKostenEditable }) => {
	const { application, setApplicationProperty, readOnly } = useApplication();

	const updatedReadOnly = checkReadOnlyInUeberarbeitung(application, readOnly, isKostenEditable);

	return (
		<>
			<ApplicationHeading title='Ausgabenplan' description={PLATZHALTER_TEXT} />

			<CreateTable
				formStruc={formStrucKosten(application, updatedReadOnly)}
				formValues={application}
				updateFormValuesFunc={setApplicationProperty}
				readOnly={updatedReadOnly}
				columnsLabel={columnsLabel(updatedReadOnly, application)}
				size='small'
			/>
		</>
	);
};
export default AusgabeplanMessefoerderung;

const columnsLabel = (readOnly: boolean, application: any) => {
	let labels = ['Art der Ausgabe', { label: 'Betrag (€)', minWidth: '7rem' }, { label: 'Erläuterung', minWidth: '30rem' }];

	if (checkIfAnyPositionNachPositionArtHasComment(readOnly, application, KOSTEN_POSITION.Ausgabe)) {
		labels.push('Erledigt', UEBERARBEITUNGS_HINWEIS_TITLE);
	}
	return labels;
};

const formStrucKosten = (application: any, readOnly: boolean) => {
	let struc: FormStrucItem[] = [];

	const allKostenPositions = get(application, P.Foerderantrag_Kostenpositions.path, []);

	for (const [index, eachKosten] of allKostenPositions.entries()) {
		if (get(eachKosten, KP_P.Allgemein_Kostenposition.path) === KOSTEN_POSITION.Ausgabe) {
			const isfieldDisabled = () => {
				if (readOnly) return readOnly;
				const ebeneDerBerechnung = get(eachKosten, KP_P.Allgemein_Kostenkategorie.schema.attributes.Allgemein_Ebene_Der_Berechnung.path, '');
				if (ebeneDerBerechnung === KATEGORIE_EBENE_DER_BERECHNUNNG.Oberkategorie) {
					return true;
				}
				return false;
			};
			let tempStruc: FormStrucItem = {
				fields: [
					{
						label: get(eachKosten, KP_P.Allgemein_Kostenkategorie.schema.attributes.Allgemein_Bezeichnung.path),
						tooltip: get(eachKosten, KP_P.Allgemein_Kostenkategorie.schema.attributes.Allgemein_Erlaeuterung_Fuer_Den_Antragsteller.path),
						path: 't.t',
						type: '',
						validation: [{ validateFunction: NonRequired }],
					},
					{
						...P.Foerderantrag_Kostenpositions.schema.attributes.Allgemein_Geplante_Gesamtsumme,
						format: 'currency',
						disabled: isfieldDisabled(),
					},
					{
						...P.Foerderantrag_Kostenpositions.schema.attributes.Allgemein_Erlaeuterungen,
						minRows: 2,
						// disabled: isfieldDisabled(),
						validation: [{ validateFunction: GetTextboxValidation() }],
					},
				],
			};

			// Adding extra fields based on condition
			if (checkIfSpecificKostenPositionHasComment(readOnly, eachKosten)) {
				tempStruc.fields.push(
					{
						...P.Foerderantrag_Kostenpositions.schema.attributes.Pruefung_Erledigt,
						validation: [{ validateFunction: ForceTrue }],
					},
					{
						label: get(eachKosten, KP_P.Pruefung_Hinweis_Fuer_Antragsteller.path, 'Bitte überarbeiten Sie diese Inhalte.'),
						path: 't.t',
						type: '',
						validation: [{ validateFunction: NonRequired }],
					},
				);
			}

			// Push the structured object to struc
			struc.push(...mapKosten([tempStruc], index));
		}
	}
	struc.push({
		fields: [
			{
				label: 'Gesamtsumme',
				path: 't.t',
				type: '',
				validation: [{ validateFunction: NonRequired }],
			},
			{
				label: DisplayEuro(get(application, P.Allgemein_Geplante_Projektausgaben.path, '0')),
				path: 't.t',
				type: '',
				validation: [{ validateFunction: NonRequired }],
			},
		],
	});
	return struc; // Return the constructed array
};

const mapKosten = (formStruc: any[], index: number) => {
	let result = formStruc.map((row) => {
		return {
			...row,
			fields: (get(row, 'fields', []) as Array<any>).map((value) => {
				let pathWithoutIndex = get(value, 'path', '') as string;
				return {
					...value,
					path:
						pathWithoutIndex.slice(0, P.Foerderantrag_Kostenpositions.path.length) +
						`.${index}` +
						pathWithoutIndex.slice(P.Foerderantrag_Kostenpositions.path.length),
				};
			}),
		};
	});
	return result;
};

export const getFormStrucAusgabeplanMessefoerderung = (application: any, readOnly: boolean) => {
	return concat(formStrucKosten(application, readOnly));
};
